import { Component, Input } from '@angular/core';
import {
    AircraftRegisterEntryDetailsDto,
    PersonnelRegisterEntryDetailsDto,
    capitaliseEnum
} from '@flyfreely-portal-ui/flyfreely';

@Component({
    selector: 'register-status-display',
    template: `
        <span class="status-block" [ngClass]="status | registerStatusClass">
            {{ displayableStatus() }}&nbsp;
            <span
                *ngIf="statusSource === 'AUTO'"
                class="fal fa-bolt-auto"
            ></span>
        </span>
    `
})
export class RegisterStatusDisplayComponent {
    @Input() status:
        | PersonnelRegisterEntryDetailsDto.Status
        | AircraftRegisterEntryDetailsDto.Status;

    @Input() statusSource?:
        | PersonnelRegisterEntryDetailsDto.StatusSource
        | AircraftRegisterEntryDetailsDto.StatusSource;

    rowPending(
        status:
            | PersonnelRegisterEntryDetailsDto.Status
            | AircraftRegisterEntryDetailsDto.Status
    ) {
        const s = PersonnelRegisterEntryDetailsDto.Status;
        return status !== s.ACTIVE && status !== s.NOT_ON_REGISTER;
    }

    displayableStatus() {
        if (this.statusSource === 'NOMINATED') {
            return 'Nominated';
        }
        return capitaliseEnum(this.status);
    }
}
